import { Component, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { BsModalService } from 'ngx-bootstrap';
import { ScoreService } from '../../../../common/services/Score.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { UserService } from '../../../../common/services/User.service';
import { Headers, Http } from '@angular/http';
import { UploadService } from 'app/common/services/Upload.service';
import { CqFileService } from 'app/common/services/CqFile.service';
import { CqScriptService } from 'app/common/services/CqScript.service';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'score-list',
  templateUrl: 'list.template.html',
  styleUrls: ['score.css'],
  providers: [BsModalService, ScoreService, UserService, ToastrService, UploadService, CqFileService, CqScriptService],
})
export class ListComponent implements OnInit {
  @Output('backScoreMode') backScoreMode = new EventEmitter();
  public modelFilter: any = {};
  public tab: any = 'call';
  public list: any = [];
  public listToExport: any = [];
  public page_size = 10;
  public currentPage = 1;
  public exportData: any = [];
  totalItem: any = 0;
  totalPage: any = 0;
  public message: { class: string; content: string } = null;
  public modalRef: any;
  public modalRef2: any;
  public model: any = {};
  public scoreTypes = [
    { id: 'default', text: 'Sắp xếp mặc định' },
    { id: 'customer', text: 'Sắp xếp theo thái độ của khách hàng' },
    { id: 'agent', text: 'Sắp xếp theo điểm điện thoại viên' },
  ];

  minDate = new Date();

  public selected: any = {};
  public is_check_all = false;
  public have_check = false;
  public checkCount = 0;
  // start score var
  public showAdvancedSearch = false;
  public listFileUpload: any = [];
  responseData: any;
  private header: Headers;
  // end score var
  public emotions: any = [];
  public endCallStatuses: any = [];
  public qcStatuses: any = [];
  public qcCategories: any = [];
  public durationMinutes: any = [];
  public wordAgentTypes: any = [];
  public wordCustomerTypes: any = [];
  public talkPercents: any = [];
  public hasComments: any = [];
  public listScripts: any = [];

  constructor(
    private modalService: BsModalService,
    private toastr: ToastrService,
    private http: Http,
    private uploadService: UploadService,
    private cqFileService: CqFileService,
    private cqScript: CqScriptService
  ) {
    this.header = new Headers();
  }

  ngOnInit() {
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
    };

    // enum EmotionType
    this.emotions = [
      { name: 'Anger', value: 1 },
      { name: 'UnHappy', value: 2 },
      { name: 'MidPriority', value: 3 },
      { name: 'Normal', value: 4 },
    ];

    // enum EmotionEndCall
    this.endCallStatuses = [
      { name: 'Bad', value: 1 },
      { name: 'Satisfy', value: 2 },
      { name: 'Normal', value: 3 },
    ];

    // enum QcStatus
    this.qcStatuses = [
      { name: 'Không chấm', value: 1 }, // NoQc
      { name: 'Đã chấm tự động', value: 2 }, // Auto
      { name: 'Đã giao chấm thủ công', value: 3 }, // ManualRequest
      { name: 'Đã chấm thủ công', value: 4 }, // ManualDone
    ];

    // enum QcCategory
    this.qcCategories = [
      { name: 'Không chấm', value: 1 },
      { name: 'Fail', value: 2 },
      { name: 'Normal', value: 3 },
      { name: 'Good', value: 4 },
    ];

    // số phút
    this.durationMinutes = [
      { name: 'Từ 1 đến 5 phút', valueFrom: 1, valueTo: 5 },
      { name: 'Từ 6 đến 10 phút', valueFrom: 6, valueTo: 10 },
      { name: 'Từ 11 đến 20 phút', valueFrom: 11, valueTo: 20 },
      { name: 'Trên 20 phút', valueFrom: 21, valueTo: 1000 },
    ];

    // enum WordAgentType
    this.wordAgentTypes = [
      { name: 'Từ khóa khuyến khích', value: 1 },
      { name: 'Từ khóa không chuyên nghiệp', value: 2 },
      { name: 'Từ khóa bị cấm', value: 3 },
    ];

    // enum WordCustomerType
    this.wordCustomerTypes = [
      { name: 'Từ khóa tích cực', value: 1 },
      { name: 'Từ khóa tiêu cực', value: 2 },
    ];

    // phần trăm thời gian thoại
    this.talkPercents = [
      { name: 'Dưới 60%', valueFrom: 0, valueTo: 60 },
      { name: 'Từ 60% đến 80%', valueFrom: 60, valueTo: 80 },
      { name: 'Từ 80% đến 90%', valueFrom: 80, valueTo: 90 },
      { name: 'Trên 90%', valueFrom: 90, valueTo: 1000 },
    ];

    // có comment
    this.hasComments = [
      { name: 'Có', value: true },
      { name: 'Không', value: false },
    ];

    this.loadData();
  }

  openDetailScore(score_id) {
    this.backScoreMode.emit({
      scoreMode: 'detail',
      score_id: score_id,
    });
  }

  submitFilter() {
    this.currentPage = 1;
    this.totalItem = this.totalPage = 0;
    if (this.modelFilter.keyword) {
      this.modelFilter.keyword = this.modelFilter.keyword.trim();
    }
    const payload = _.assign({}, this.modelFilter);
    if (payload.from) {
      payload.from = moment(payload.from).format('YYYY-MM-DD HH:mm');
    }
    if (payload.to) {
      payload.to = moment(payload.to).format('YYYY-MM-DD HH:mm');
    }
    this.loadData(payload);
  }

  checkAll() {
    this.is_check_all = !this.is_check_all;
    this.list.forEach(e => {
      this.selected[e._id] = this.is_check_all;
      if (this.selected[e._id]) {
        this.checkCount += 1;
      } else {
        this.checkCount -= 1;
      }
    });
  }

  selectOne(contact_id) {
    this.selected[contact_id] = !this.selected[contact_id];
    if (this.selected[contact_id]) {
      this.checkCount += 1;
    } else {
      this.checkCount -= 1;
    }
    this.is_check_all = true;
    this.list.forEach(e => {
      if (!this.selected[e._id]) {
        this.is_check_all = false;
      }
    });
  }

  openUploadModal(template: TemplateRef<any>, id?: any) {
    this.message = null;
    this.listFileUpload = [];
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  changeFile($event) {
    if ($event.target.value.length != 0) {
      const files = $event.srcElement.files;
      for (let i = 0; i < files.length; i++) {
        if (this.listFileUpload.length < 10) {
          if (files[i].size > 10485760) {
            this.toastr.error('', 'Kích thức file ' + files[i].name + ' vượt quá 10MB. Vui lòng thử lại', {
              timeOut: 2000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            files[i].sizeMB = (files[i].size / 1048576).toFixed(2);
            this.listFileUpload.push(files[i]);
          }
        } else {
          this.toastr.error('', 'Chỉ được upload tối đa 10 files', {
            timeOut: 2000,
            positionClass: 'toast-bottom-right',
          });
          break;
        }
      }
      $('#fileUploadInput').val('');
    } else {
    }
  }

  deleteAudioFile(index) {
    this.listFileUpload.splice(index, 1);
  }

  deleteAllAudioFile() {
    this.listFileUpload = [];
  }

  uploadAudioFile(file) {
    file.is_loading = true;
    this.uploadService.uploadAudio(file).then((res: any) => {
      if (!res.error) {
        const data = {
          name: file.name,
          ai_data_task_id: res.data.ai_data.task_id,
          file_path: res.data.link,
        };
        file.status = res.data.ai_data.status == '0' ? 'Thành công' : 'Thất bại';
        if (file.status == 'Thành công') {
          this.cqFileService.create(data).subscribe(
            res => {
              if (res) {
                const error = res.error;
                if (error) {
                  this.toastr.error('Thêm mới thất bại', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                } else {
                  this.loadData();
                  this.modalRef.hide();
                }
              }
            },
            error => {
              this.message = {
                class: 'alert dark alert-danger',
                content: error.message,
              };
            }
          );
        }
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
      file.is_loading = false;
    });
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    // this.selected = {};
    // this.have_check = false;
    // this.is_check_all = false;
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.cqScript.list().subscribe(res => {
      this.listScripts = res.data.list;
    });

    this.cqFileService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200) {
            this.list = res.data.list;
            this.is_check_all = true;
            this.list.forEach(value => {
              value.created_at = moment(value.createAt).format('YYYY-MM-DD HH:mm');
              if (!this.selected[value._id]) {
                this.is_check_all = false;
              }
              this.listScripts.map(e => {
                if (e._id == value.script_id) {
                  value.script_name = e.name;
                  value.script_maxscore = e.maxscore;
                  value.normal_score = e.normal_score;
                  value.good_score = e.good_score;
                }
              });
              value.createAt = moment(value.createdAt).format('YYYY-MM-DD HH:mm:ss');
              let score = 0;
              if (value.result && value.result.id_score_criteria && value.result.id_score_criteria.length) {
                value.result.id_score_criteria.map(item => {
                  if (item.result) {
                    score += Number(item.result);
                  }
                });
              }
              value.score = score;
              value.percent = ((value.score / value.script_maxscore) * 100).toFixed(1);
              value.status =
                Number(value.percent) < Number(value.normal_score)
                  ? 'Chưa đạt'
                  : Number(value.percent) < Number(value.good_score)
                    ? 'Trung bình'
                    : 'Đạt';

              return value;
            });

            console.log(this.list, '----------------- this.list ');

            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
          } else {
            this.list = [];
          }
        },
        err => {
          this.list = [];
        }
      );
  }

  setPage(page: number) {
    const payload = _.assign({}, this.modelFilter);
    if (payload.from) {
      payload.from = moment(payload.from).format('YYYY-MM-DD HH:mm');
    }
    if (payload.to) {
      payload.to = moment(payload.to).format('YYYY-MM-DD HH:mm');
    }
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(payload);
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData(payload);
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  uploadAllAudioFile() {
    for (let i = 0; i < this.listFileUpload.length; i++) {
      if (!this.listFileUpload[i].is_loading && this.listFileUpload[i].status != 'Thành công') {
        this.uploadAudioFile(this.listFileUpload[i]);
      }
    }

    let count = 0;
    for (let i = 0; i < this.listFileUpload.length; i++) {
      if (!this.listFileUpload[i].is_loading && this.listFileUpload[i].status != 'Thành công') {
        count += 1;
      }
    }
    if (count == 0) {
      this.modalRef.hide();
    }
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    const delete_ids = [];
    Object.keys(this.selected).forEach(
      function (key) {
        if (this.selected[key]) {
          delete_ids.push(key);
        }
      }.bind(this)
    );
    return this.cqFileService.deleteMany({ files_ids: delete_ids }).subscribe(res => {
      if (!res.error) {
        this.toastr.success('Xóa thành công', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        setTimeout(
          function () {
            this.loadData();
            this.checkCount -= delete_ids.length;
          }.bind(this),
          1000
        );
        // this.modalRef2.hide();
      } else {
        this.toastr.error('Xóa không thành công', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/score/list.component.ts